import React from 'react';

const Label = ({ config }) => {
  return (
    <div className={config.classContainer} >
      <label className={config.classLabel}>{config.label}</label>
    </div>
  )
}

export default Label;